import * as Sentry from '@sentry/react';

export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.consoleLoggingIntegration({ levels: ['error'] }),
    ],
    tracesSampleRate: 0.1,
    enableLogs: true,
  });
}

export function setSentryUser(user: { uid: string; email: string | null }) {
  Sentry.setUser({ id: user.uid, email: user.email ?? undefined });
}

export function clearSentryUser() {
  Sentry.setUser(null);
}
